var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"target":_vm.target,"placement":_vm.placement}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }